import { getVersions } from '@/src/hooks/useVersionCheck';
import * as Sentry from '@sentry/nextjs';
import { useRunOnce } from '@fabric-app/hooks/useRunOnce';
import { getCompatPlatform } from '@fabric-app/compat/capabilities/platform';

export const useSentryInit = () => {
  useRunOnce(async () => {
    const versions = await getVersions();
    Sentry.setTag('app_device_platform', getCompatPlatform().getPlatform());
    Sentry.setTag('app_device_version', versions.appVersion || versions.desktopVersion);
  });
};
